function parseJson(value, fallback) {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

export class PropertyModalContent {
  constructor(modalElement) {
    this.modal = modalElement;
    if (!this.modal) return;

    this.tagline = this.modal.querySelector(".property-modal__tagline");
    this.title = this.modal.querySelector(".property-modal__title");
    this.mediaCarousel = this.modal.querySelector(
      ".property-modal__media-carousel",
    );
    this.attributes = this.modal.querySelector(".property-modal__attributes");
    this.description = this.modal.querySelector(".property-modal__description");
    this.price = this.modal.querySelector('[data-modal-field="price"]');
    this.booking = this.modal.querySelector('[data-modal-field="booking"]');

    this.mediaNav = this.modal.querySelector(".property-modal__media-nav");
    this.mediaPrev = this.modal.querySelector("[data-modal-media-prev]");
    this.mediaNext = this.modal.querySelector("[data-modal-media-next]");
    this.priceWrap = this.modal.querySelector(".property-modal__price");

    this.flickity = null;

    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  reset() {
    this.tagline.textContent = "";
    this.title.innerHTML = "";
    this.description.innerHTML = "";
    this.price.textContent = "";
    this.booking.setAttribute("href", "");
    this.attributes.innerHTML = "";
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
    this.mediaCarousel.innerHTML = "";
    this.mediaCarousel.style.display = "";

    if (this.priceWrap) {
      this.priceWrap.style.visibility = "visible";
    }

    if (this.mediaNav) {
      this.mediaNav.hidden = false;
    }
  }

  buildAttributes(attributes) {
    attributes.forEach((attribute) => {
      const attrEl = document.createElement("div");
      attrEl.classList.add("property-modal__attr");

      const labelEl = document.createElement("h4");
      labelEl.classList.add("property-modal__attr-label", "display", "text-sm");
      labelEl.textContent = attribute.label || "";

      const listEl = document.createElement("ul");
      listEl.classList.add("property-modal__attr-list");

      (attribute.list || []).forEach((attributeItem) => {
        const itemEl = document.createElement("li");
        itemEl.classList.add("property-modal__attr-item");

        const iconEl = document.createElement("img");
        iconEl.classList.add("property-modal__attr-icon");
        iconEl.src = attributeItem.icon?.url || "";
        iconEl.alt = "";

        const textEl = document.createElement("span");
        textEl.classList.add(
          "property-modal__attr-text",
          "text-sm",
          "tracking-wide",
        );
        textEl.textContent = attributeItem.label || "";

        itemEl.appendChild(iconEl);
        itemEl.appendChild(textEl);
        listEl.appendChild(itemEl);
      });

      attrEl.appendChild(labelEl);
      attrEl.appendChild(listEl);
      this.attributes.appendChild(attrEl);
    });
  }

  buildMedia(media) {
    if (!media.length) {
      if (this.mediaNav) this.mediaNav.hidden = true;
      return;
    }

    media.forEach((image) => {
      const itemEl = document.createElement("div");
      itemEl.classList.add("property-modal__media-item");

      const imgEl = document.createElement("img");
      imgEl.classList.add("property-modal__media-img");
      imgEl.src = image.url || "";
      imgEl.alt = image.alt || "";

      if (image.attributes?.srcset) imgEl.srcset = image.attributes.srcset;
      if (image.attributes?.sizes) imgEl.sizes = image.attributes.sizes;

      itemEl.appendChild(imgEl);
      this.mediaCarousel.appendChild(itemEl);
    });

    if (media.length === 1) {
      if (this.mediaNav) this.mediaNav.hidden = true;
      return;
    }

    this.mediaCarousel.style.display = "block";

    this.flickity = new Flickity(this.mediaCarousel, {
      cellAlign: "center",
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
    });
  }

  populate(trigger) {
    const tagline = trigger.getAttribute("data-modal-tagline") || "";
    const title = trigger.getAttribute("data-modal-title") || "";
    const description = trigger.getAttribute("data-modal-description") || "";
    const price = trigger.getAttribute("data-modal-price") || "";
    const media = parseJson(trigger.getAttribute("data-modal-media"), []);
    const attributes = parseJson(
      trigger.getAttribute("data-modal-attributes"),
      [],
    );
    const booking = trigger.getAttribute("data-modal-booking") || "";

    this.reset();

    this.tagline.textContent = tagline;
    this.title.innerHTML = title;
    this.description.innerHTML = description;
    this.booking.setAttribute("href", booking);

    if (price === "") {
      if (this.priceWrap) this.priceWrap.style.visibility = "hidden";
    } else {
      if (this.priceWrap) this.priceWrap.style.visibility = "visible";
      this.price.textContent = price;
    }

    this.buildAttributes(attributes);
    this.buildMedia(media);
  }

  handleModalOpen(event) {
    const { id, trigger } = event.detail;
    if (id !== this.modal.id || !trigger) return;

    this.populate(trigger);
  }

  handleModalClose(event) {
    const { id } = event.detail;
    if (id !== this.modal.id) return;

    this.reset();
  }

  init() {
    if (!this.modal) return this;

    window.addEventListener("modal:open", this.handleModalOpen);
    window.addEventListener("modal:close", this.handleModalClose);

    if (this.mediaPrev) {
      this.mediaPrev.addEventListener("click", () => {
        if (this.flickity) this.flickity.previous();
      });
    }

    if (this.mediaNext) {
      this.mediaNext.addEventListener("click", () => {
        if (this.flickity) this.flickity.next();
      });
    }

    return this;
  }
}
